// src/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported as isAnalyticsSupported } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import {
  getMessaging,
  getToken,
  isSupported as isMessagingSupported,
  onMessage,
} from "firebase/messaging";

/* ------------------------- Firebase config ------------------------- */
const firebaseConfig = {
  apiKey: "AIzaSyAv2dcVcYiVduGZmfYxtpu7U_DekBOwzUY",
  authDomain: "whisperwall-9080d.firebaseapp.com",
  projectId: "whisperwall-9080d",
  storageBucket: "whisperwall-9080d.firebasestorage.app",
  messagingSenderId: "864329510791",
  appId: "1:864329510791:web:8545388970c2edde19ed22",
  measurementId: "G-2LYY2H1256",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

/* ----------------------- App Check (reCAPTCHA v3) ----------------------- */
if (typeof window !== "undefined") {
  if (process.env.NODE_ENV !== "production") {
    // use window to avoid ESLint 'restricted-globals'
    // @ts-ignore
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6LeC_tkrAAAAAIH4iCmcK1hs3UoiEt6t0Qm8JzW5"),
    isTokenAutoRefreshEnabled: true,
  });
}

/* ---------------------------- Core SDKs ---------------------------- */
export const db = getFirestore(app);
export const storage = getStorage(app);

export let analytics = null;
if (typeof window !== "undefined") {
  isAnalyticsSupported()
    .then((ok) => {
      if (ok) analytics = getAnalytics(app);
    })
    .catch(() => {});
}

/* --------------------------- Web Push (FCM) --------------------------- */
const VAPID_PUBLIC_KEY =
  "BFRfnMBD9OcC6s0vyi4jQGR_d1Dm6vr_TbyQYl--2nDbPaMGEMHM8yxlYse9aUC18e3shAMgJBhQKOO7YLU2sVs";

/**
 * Ask for permission, register the SW (always), and get the FCM token.
 */
export async function initPushForThisDevice(userIdOrAnonId = "anon") {
  if (typeof window === "undefined") return { ok: false, reason: "ssr" };

  const supported = await isMessagingSupported().catch(() => false);
  if (!supported) return { ok: false, reason: "unsupported" };

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return { ok: false, reason: "denied" };

  // 1) Explicitly register (or re-register) the SW at the site root.
  let swReg = null;
  try {
    if ("serviceWorker" in navigator) {
      swReg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      console.log("✅ Service Worker registered:", swReg);
      // Wait until it's active for stability
      await navigator.serviceWorker.ready;
    }
  } catch (err) {
    console.error("❌ Service Worker registration failed:", err);
    return { ok: false, reason: "sw-register-failed" };
  }

  // 2) Get token, passing the SW registration explicitly
  try {
    const messaging = getMessaging(app);
    const token = await getToken(messaging, {
      vapidKey: VAPID_PUBLIC_KEY,
      serviceWorkerRegistration: swReg || (await navigator.serviceWorker.ready),
    });
    if (!token) return { ok: false, reason: "no-token" };
    return { ok: true, token };
  } catch (err) {
    console.error("FCM getToken failed:", err);
    return { ok: false, reason: "getToken-failed" };
  }
}

/**
 * Listen for messages while the page is open.
 */
export async function onForegroundMessage(handler) {
  const supported = await isMessagingSupported().catch(() => false);
  if (!supported) return () => {};
  const messaging = getMessaging(app);
  return onMessage(messaging, handler);
}
